/**
 *
 * Live Registration Form - handling show-hide address fields when selected country is US
 *
 * 
 */

jQuery(document).ready(function () {

    jQuery('.show-US-fields').addClass("hideThis");
    jQuery('.show-US-fields').removeClass("showThis");

    jQuery('#Country').change(function(){
        var showUSAddress = jQuery(this).data('showusaddress')
        if (!showUSAddress) {
          return
        }

        var selectedCountry = jQuery(this).children("option:selected").val();
        if (selectedCountry == "United States") {
            jQuery('.show-US-fields').addClass("showThis");
            jQuery('.show-US-fields').removeClass("hideThis");
        } else {
            jQuery('.show-US-fields').addClass("hideThis");
            jQuery('.show-US-fields').removeClass("showThis");
        }
    });

});
